// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__10MCL","productName":"Table_productName__26HWd"};